export const zh = () => {
  return {
    reset_password: "重設密碼",
    verified_and_reset: "你的身份已驗證，請重設你的密碼",
    password: "密碼",
    set_your_password: "設定你的密碼",
    min_8_character: "必須至少8個字符或更多",
    at_least_1_captial: "包含至少一個大寫字母",
    at_least_1_num: "包含至少一個數字",
    forget_password_btn: "提交",
    email_success: "已經成功驗證",
    email_success_title: "你的電郵地址已驗證",
    link_has_exp: "鏈接已失效",
    email_failed: "電郵地址驗證失敗",
    // email_failed_title: "請輸入註冊時使用的電郵地址來接收驗證信件",
    reset_failed: "重設密碼連結已過期或已經被使用",
    // reset_failed_title: "請輸入註冊時使用的電郵地址來接收重設密碼連結",
    reset_successed: "密碼更新成功",
    reset_succcess_title: "你的密碼已更新成功，請用新密碼登入你的帳戶",
    EXPIRED_OOB_CODE: "操作代码已过期",
    INVALID_OOB_CODE: "操作代码无效。如果代码格式错误、过期或已被使用，则可能发生这种情况",
    USER_DISABLED: "管理员已禁用该用户帐户",
    EMAIL_NOT_FOUND: "没有与此标识符对应的用户记录。该用户可能已被删除",
    OPERATION_NOT_ALLOWED: "此项目的密码登录被禁用",
    network_err: "未知網絡錯誤",
    pin_code_reset_success: "郵箱已驗證，請在APP端重設PIN碼。",
    pin_code_reset_failed: "郵箱驗證失敗，請在APP端重試。",
  }
}

export const en = () => {
  return {
    reset_password: "Reset Password",
    verified_and_reset: "Your identity has been verified, please reset your password",
    password: "Password",
    set_your_password: "Your password",
    min_8_character: "Must be at least 8 characters or more",
    at_least_1_captial: "Include at least one uppercase letter",
    at_least_1_num: "Include at least one number",
    forget_password_btn: "Reset Password",
    email_success: "Successfully verified",
    email_success_title: "Your email address has been verified",
    link_has_exp: "Link has expired",
    email_failed: "Email address verification failed",
    // email_failed_title: "Please enter the email address used during registration to receive verification letters",
    reset_failed: "The reset password link has expired or has already been used",
    // reset_failed_title: "Please enter the email address used during registration to receive the reset password link",
    reset_successed: "Password updated successfully",
    reset_succcess_title: "Your password has been successfully updated. Please log in to your account with the new password",
    EXPIRED_OOB_CODE: "The action code has expired",
    INVALID_OOB_CODE: "The action code is invalid.This can happen if the code is malformed, expired, or has already been used",
    USER_DISABLED: "The user account has been disabled by an administrator",
    EMAIL_NOT_FOUND: "There is no user record corresponding to this identifier.The user may have been deleted",
    OPERATION_NOT_ALLOWED: "Password sign-in is disabled for this project",
    network_err: "Unknown network error",
    pin_code_reset_success: "The email address has been verified. Please reset the PIN in the APP.",
    pin_code_reset_failed: "Email verification failed, please try again on the APP.",
  }
}